import { AbstractControl } from '@angular/forms';

/**
 * Validador personalizado para desplegables
 */
export class StringValidators {
    static NotStringValidator(control: AbstractControl): { [key: string]: boolean } | null {
      return control.value && typeof control.value === 'string' ? { 'notString': true } : null;
    }

    static isSearcheable(value: any): boolean {
      return value && typeof value === 'string' && value.length > 3 ? true : false;
    }
}